import { NuxtLink } from '#components';

export default defineNuxtPlugin((nuxt) => {
  nuxt.vueApp.component('NuxtLink', NuxtLink);
});
